import React from 'react';

export default function UserProfile() {
 return <>My Profile</>;
}
